export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8319.8ca0d604.jpg";